var map = {
	"./apple.svg": "bbfa",
	"./avatars/avatar-pasaz-grunwaldzki.svg": "f6d0",
	"./facebook.svg": "282f",
	"./google.svg": "ccc8",
	"./icon-chat.svg": "9d53",
	"./icon-close.svg": "ffed",
	"./icon-gift.svg": "9f9b",
	"./icon-loading.svg": "0830",
	"./logos/logo-centrum-riviera.svg": "aa3f",
	"./settings.svg": "1354"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0591";